// extracted by mini-css-extract-plugin
module.exports = {"order":"filterDiet_order__34QRx","label":"filterDiet_label__TxSyL","select":"filterDiet_select__21Ut_"};